export enum AffiliateApplicationStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  OnHold = 'on_hold',
}

export enum IdentifierType {
  EvmAddress = 'evm_address',
  SolanaAddress = 'solana_address',
  SuiAddress = 'sui_address',
  XRPLAddress = 'xrpl_address',
  StellarAddress = 'stellar_address',
  Email = 'email',
}

export type AffiliateApplicationFormFieldType =
  | 'text'
  | 'email'
  | 'textarea'
  | 'number'
  | 'select'
  | 'checkbox'
  | 'radio'
  | 'url';

export interface AffiliateApplicationFormFieldValidation {
  minLength?: number;
  maxLength?: number;
  min?: number;
  max?: number;
  pattern?: string;
}

export interface AffiliateApplicationFormField {
  id: string;
  label: string;
  type: AffiliateApplicationFormFieldType;
  required: boolean;
  placeholder?: string;
  description?: string;
  options?: string[];
  validation?: AffiliateApplicationFormFieldValidation;
  order: number;
}

export interface AffiliateApplicationFormConfig {
  id: string;
  projectId: string;
  formFields: AffiliateApplicationFormField[];
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PutFormConfigDTO {
  form_fields: Array<{
    id: string;
    label: string;
    type: AffiliateApplicationFormFieldType;
    required: boolean;
    placeholder?: string;
    description?: string;
    options?: string[];
    validation?: AffiliateApplicationFormFieldValidation;
    order: number;
  }>;
  enabled?: boolean;
}

export interface AffiliateApplication {
  id: string;
  projectId: string;
  userIdentifier: string;
  userIdentifierType: IdentifierType;
  status: AffiliateApplicationStatus;
  formResponses: Record<string, string | number | boolean | string[]>;
  adminNotes?: string;
  rejectionReason?: string;
  processedByUserId?: string;
  processedAt?: string;
  assignedTier?: {
    id: string;
    name: string;
    slug: string;
    rank: number;
  };
  createdAt: string;
  updatedAt: string;
}

export interface AffiliateApplicationPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface GetAffiliateApplicationsParams {
  status?: AffiliateApplicationStatus;
  page?: number;
  page_size?: number;
  sort_by?: 'created_at' | 'updated_at' | 'status';
  sort_order?: 'asc' | 'desc';
  search?: string;
}

export interface ApproveAffiliateApplicationDto {
  tier_id: string;
  protection_days: number;
  admin_notes?: string;
}

export interface RejectAffiliateApplicationDto {
  rejection_reason: string;
  admin_notes?: string;
}

export interface HoldAffiliateApplicationDto {
  admin_notes?: string;
}

export interface UpdateAffiliateApplicationDto {
  admin_notes?: string;
}
